import { fetchWithToken } from "../../interceptors/fetchInterceptor";
import {
  API_USER_BY_ID,
  MAIN_URL,
  PORT_FOR_AUTH,
} from "../../constants/constants";
import { GET_USER_INFO } from "../types";

export const getUserInfoById = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_USER_BY_ID + id,
    );

    const data = await response.json();

    dispatch({
      type: GET_USER_INFO,
      data: data,
    });
  };
};
